import React, { createContext, useContext, useState, useCallback } from "react";

const PageTitleContext = createContext(null);

export function PageTitleProvider({ children }) {
	const [state, setState] = useState({
		title: null,
		extra: null,
	});

	const setPageTitle = useCallback((title, extra = null) => {
		setState({ title, extra });
	}, []);

	const clearPageTitle = useCallback(() => {
		setState({ title: null, extra: null });
	}, []);

	return (
		<PageTitleContext.Provider
			value={{ ...state, setPageTitle, clearPageTitle }}
		>
			{children}
		</PageTitleContext.Provider>
	);
}

export function usePageTitle() {
	const ctx = useContext(PageTitleContext);
	if (!ctx) {
		return {
			title: null,
			extra: null,
			setPageTitle: () => {},
			clearPageTitle: () => {},
		};
	}
	return ctx;
}

export default PageTitleContext;
